//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DelayPopup',
  props: {
    btnText: {
      type: String,
      default: '收藏'
    }
  },
  methods: {
    /* 取消关闭消息提示 */closePopup: function closePopup() {
      this.$emit('closePopup');
    },
    /* 添加收藏 */addWanted: function addWanted() {
      this.$emit('addWanted');
    }
  }
};